@if (loader() !== 'none') {
  <div
    [ngClass]="{ loading: isLoading() }"
    class="ui-loader ui-loader--local ui-loader--size-{{ loader() }}"
  >
    <pxw-icon icon="loading" [spin]="true"></pxw-icon>
  </div>
}
@if (isHttpResource()) {
  <img
    [ngSrc]="imageUrl()"
    [alt]="alt()"
    [priority]="priority()"
    [loading]="loadingStrategy()"
    [fill]="imgDimensions().fill"
    [width]="imgDimensions().width"
    [height]="imgDimensions().height"
    [sizes]="sizes()"
    [loaderParams]="mergedLoaderParams()"
    [ngClass]="{ 'is-loading': isLoading() }"
    [ngStyle]="{ objectFit: objectFit() }"
    (load)="onImageLoad()"
    (error)="onImageError()"
  />
} @else {
  <img
    [src]="imageUrl()"
    [alt]="alt()"
    [ngClass]="{ 'is-loading': isLoading() }"
    [ngStyle]="{ objectFit: objectFit() }"
    (load)="onImageLoad()"
    (error)="onImageError()"
  />
}
